<template>
    <!-- 收货发票 -->
    <div class="address-section">
        <div class="section-title">
            <div class="title-container">
                <div class="line"></div>
                <span>开票信息</span>
            </div>
            <el-button type="text" class="add-address-btn" @click="openAddressDialog">+ 新增抬头</el-button>
        </div>
        <div class="address-list">
            <div class="address-card" :class="{ 'active': localSelectedIndex == index }"
                v-for="(address, index) in fapiaoList" :key="index" @click="selectFapiao(address, index)">
                <img src="../../../assets/images/26.png" alt="" v-if="localSelectedIndex == index">
                <img src="../../../assets/images/27.png" alt="" v-else>
                <div class="address-header" v-if="address.type_str">
                    <div class="label-box">{{ address.type_str }}</div>
                    <div>
                        <span class="name">{{ address.username }}</span>
                        <span class="phone">{{ address.mobile }}</span>
                    </div>
                </div>
                <div class="address-content">
                    {{ address.province }}{{ address.city }}{{ address.district }}{{ address.detail }}
                </div>
                <div class="address-footer">
                    <el-button v-if="address.is_default == 1" type="primary" size="small" plain>
                        默认发票
                    </el-button>
                    <el-button v-else type="primary" size="small" plain @click.native="setFapiaoFn(address, index)">
                        设置为默认发票
                    </el-button>
                    <el-button type="text" size="small" @click.native="editAddressFn(address)">编辑</el-button>
                    <el-button type="text" size="small"
                        @click.native="dialogVisibleDelete = true; chooseAddress = address">删除</el-button>
                </div>
            </div>
        </div>

        <el-dialog title="新增发票抬头" :visible.sync="dialogVisible" width="80%" :before-close="handleClose"
            v-if="dialogVisible">
            <div>
                <NewFapiao ref="NewFapiao" @fapiaoAdded="handleAddressAdded" @close="handleClose"
                    :address="chooseAddress" :isEdit="isEdit"></NewFapiao>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisibleDelete" width="30%" :before-close="handleClose">
            <span>是否删除该发票？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleDelete = false">取 消</el-button>
                <el-button type="primary" @click="deleteFapiaoFn(chooseAddress)">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import NewAddress from './NewAddress.vue'
import NewFapiao from './NewFapiao.vue'
export default {
    name: 'ShippingAddress',
    components: {
        NewAddress,
        NewFapiao,
    },
    props: {
        fapiaoList: {
            type: Array,
            default: () => []
        },
        selectedFapiaoIndex: {
            type: [Number, String],
            default: -1
        }
    },


    data() {
        return {
            // 声明本地属性，以 prop 为初始值
            localSelectedIndex: this.selectedFapiaoIndex,
            dialogVisible: false,
            dialogVisibleDelete: false,
            chooseAddress: {},
            isEdit: false
        }
    },

    watch: {
        selectedFapiaoIndex: {
            handler(newVal) {
                this.localSelectedIndex = newVal;
            },
            immediate: true
        }
    },

    methods: {
        // 选择发票
        selectFapiao(address, index) {
            this.localSelectedIndex = index;
            this.$emit('selectFapiao', address.aid);
        },
        openAddressDialog() {
            // this.resetForm(); // 新增时重置表单
            this.chooseAddress = {}
            this.dialogVisible = true;
        },
        // 处理发票添加成功事件
        handleAddressAdded() {
            // 发射事件通知父组件
            this.$emit('fapiaoListUpdated');
        },

        // 设置默认发票
        setFapiaoFn(address, index) {
            console.log('设置默认发票', address);
            this.$dapi.setFapiaoFn({
                aid: address.aid
            }).then(res => {
                this.$message.success('设置默认发票成功');
                this.$emit('setFapiaoFn', address);
                this.localSelectedIndex = 0
            }).catch(err => {
                this.$message.error(err);
            })
        },

        handleClose() {
            this.dialogVisible = false;
        },

        // 删除发票
        deleteFapiaoFn(address, index) {
            console.log(address);

            this.$dapi.deleteFapiaoFn({
                aid: address.aid
            }).then(res => {
                this.$message.success('删除发票成功');
                this.$emit('fapiaoListUpdated');
                this.dialogVisibleDelete = false
                this.localSelectedIndex = 0
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 编辑发票
        editAddressFn(address) {
            console.log('打开弹窗');
            this.chooseAddress = JSON.parse(JSON.stringify(address));
            this.dialogVisible = true
            this.isEdit = true
        }
    }
}
</script>



<style scoped>
.title-container {
    display: flex;
    align-items: center;
}

.line {
    width: 4px;
    height: 18px;
    background: #286CED;
    border-radius: 0px 0px 0px 0px;
    margin-right: 12px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.section-title i {
    margin-right: 8px;
    color: #409eff;
}

/* 收货发票样式 */
.address-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.active {
    border: 1px solid #409eff !important;
}

.add-address-btn {
    margin-left: auto;
    color: #FF9735;
}

.address-list {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.address-card {
    width: 300px;
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    text-align: left;
}

.address-card img {
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 0;
    right: 0;
}

.address-card:hover {
    border-color: #409eff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.address-header {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.label-box {
    /* width: 30px;
    height: 22px; */
    padding: 3px 8px;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #FF9735;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #FF9735;
    margin-right: 10px;
}



.name {
    font-weight: bold;
    margin-right: 10px;
}

.phone {
    color: #666;
}

.address-content {
    margin-bottom: 15px;
    color: #666;
    line-height: 1.5;
}

.address-footer {
    display: flex;
    align-items: center;
    gap: 10px;
}
</style>
